import { HttpErrorResponse } from '@angular/common/http';
import { AppError } from '@rms/sdk/errors';

export class UserEmailInUseError extends AppError {
  constructor(error: HttpErrorResponse) {
    super(error, 'profile.errors.email-in-use');
  }
}
